import React from 'react'
import { withRouter, Route } from 'react-router-dom'

import WxworkEntry from '../pages/udeskSide/wxworkEntry'
import UdeskSide from '../pages/udeskSide/udeskSide'
import BrandWxList from '../pages/brandwx/list'
import EditBrandWx from '../pages/brandwx/editbrandwx'

class AppRoute extends React.Component {
  render () {
    return (
      <div>
        {/* udesk侧边栏 */}
        <Route path="/main/udeskSide/wxworkEntry" component={WxworkEntry}/>
        <Route path="/main/udeskSide/udeskSide" component={UdeskSide}/>
        <Route path="/main/brandwx/list" component={BrandWxList}/>
        <Route path="/main/brandwx/editbrandwx/:id" component={EditBrandWx}/>
      </div>
    )
  }
}

export default withRouter(AppRoute)



// WEBPACK FOOTER //
// ./src/routes/app-route.js